export const DocumentoHeaderConfigLoad = async (data, setOcultarProdutosServicos, setManterAberto, setRecorrente, setPreDocumento, setAnoMesRefByMov) => {

    setOcultarProdutosServicos(data.ocultar_produtos_servicos)
    setManterAberto(data.manter_aberto)
    setRecorrente(data.recorrente)
    setPreDocumento(data.pre_documento)
    setAnoMesRefByMov(data.anomesref_bymov)
    
}